export default __webpack_public_path__ + "static/media/logo_main.818f6f44.png";